import { LayoutGrid, List, Search } from 'lucide-react';
import { type ChangeEvent, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

import { ViewType } from '../home.utils';

type HomeHeaderProps = {
  onProcessSearch: (e: ChangeEvent<HTMLInputElement>) => void;
  onViewChange: (view: ViewType) => void;
  selectedView: ViewType;
};

const HomeHeader = ({
  onProcessSearch,
  onViewChange,
  selectedView
}: HomeHeaderProps) => {
  const searchRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    searchRef.current?.focus();
  }, []);

  return (
    <header className="flex min-h-[40px] w-full flex-wrap items-center gap-3">
      {/* Search bar */}
      <div className="flex h-10 min-w-0 flex-[1_1_200px] items-center overflow-hidden rounded-md border border-input bg-white">
        <div className="flex aspect-square h-full shrink-0 items-center justify-center text-muted-foreground">
          <Search size={16} />
        </div>
        <input
          className="min-w-0 flex-1 border-none bg-transparent text-[15px] outline-none placeholder:text-muted-foreground"
          onChange={onProcessSearch}
          placeholder="Search..."
          ref={searchRef}
        />
      </div>

      {/* Layout toggle */}
      <div className="flex h-10 shrink-0 items-center rounded-md border border-input bg-white p-1">
        <button
          className={cn(
            'flex h-full cursor-pointer items-center justify-center rounded-sm px-2.5 transition-colors duration-200',
            selectedView === ViewType.Grid
              ? 'bg-muted text-foreground'
              : 'text-muted-foreground hover:text-foreground'
          )}
          onClick={() => onViewChange(ViewType.Grid)}
          type="button"
        >
          <LayoutGrid size={17} />
        </button>
        <button
          className={cn(
            'flex h-full cursor-pointer items-center justify-center rounded-sm px-2.5 transition-colors duration-200',
            selectedView === ViewType.List
              ? 'bg-muted text-foreground'
              : 'text-muted-foreground hover:text-foreground'
          )}
          onClick={() => onViewChange(ViewType.List)}
          type="button"
        >
          <List size={17} />
        </button>
      </div>

      {/* Add new project button */}
      <Link
        className="flex h-[38px] shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-indigo-700 px-4 font-semibold text-sm text-white transition-colors duration-200 hover:bg-indigo-800"
        to="/new"
      >
        Add a new project
      </Link>
    </header>
  );
};

export default HomeHeader;
